import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import TenableCloudSecurityMappingForm from "./TenableCloudSecurityMappingForm";
import TenableCloudSecurityCredentialsForm from "./TenableCloudSecurityCredentialsForm";
import { columnRenderArrayData } from "utils/tableUtils";

export default function TenableCloudSecurityConfigListing(props) {
  const columns = useMemo(
    () => [
      {
        title: "Account",
        dataIndex: "accountId",
        width: 240,
        render: columnRenderArrayData,
      },
    ],
    []
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={TenableCloudSecurityMappingForm}
      CredentialsForm={TenableCloudSecurityCredentialsForm}
      extraColumns={columns}
    />
  );
}